// MARK: - Table of Contents
// 1. Submission Workflow Status
// 2. Client-Facing Submission Status
// 3. Partner Referral Status
// 4. Submission Message Contract

// MARK: - Submission Workflow Status

export const litigationSubmissionWorkflowStatuses = Object.freeze([
  Object.freeze({ value: "new", label: "New", clientStatus: "submitted" }),
  Object.freeze({ value: "inReview", label: "In Review", clientStatus: "underReview" }),
  Object.freeze({ value: "needsInformation", label: "Needs Information", clientStatus: "informationRequested" }),
  Object.freeze({ value: "readyForReferral", label: "Ready for Referral", clientStatus: "underReview" }),
  Object.freeze({ value: "referralInProgress", label: "Referral in Progress", clientStatus: "partnerReview" }),
  Object.freeze({ value: "placedWithPartner", label: "Placed with Partner", clientStatus: "transferred" }),
  Object.freeze({ value: "retainedInHouse", label: "Retained In-House", clientStatus: "underReview" }),
  Object.freeze({ value: "notMovingForward", label: "Not Moving Forward", clientStatus: "closed" }),
  Object.freeze({ value: "closed", label: "Closed", clientStatus: "closed" })
]);

export const litigationSubmissionWorkflowStatusValues = Object.freeze(
  litigationSubmissionWorkflowStatuses.map(status => status.value)
);

export const litigationSubmissionWorkflowStatusLabel = value =>
  litigationSubmissionWorkflowStatuses.find(status => status.value === value)?.label ?? "New";

export const clientStatusForLitigationSubmissionWorkflow = value =>
  litigationSubmissionWorkflowStatuses.find(status => status.value === value)?.clientStatus ?? "submitted";

// MARK: - Client-Facing Submission Status

export const litigationSubmissionClientStatuses = Object.freeze([
  Object.freeze({ value: "submitted", label: "Submitted" }),
  Object.freeze({ value: "underReview", label: "Under Review" }),
  Object.freeze({ value: "informationRequested", label: "Information Requested" }),
  Object.freeze({ value: "partnerReview", label: "Partner Review" }),
  Object.freeze({ value: "transferred", label: "Transferred" }),
  Object.freeze({ value: "closed", label: "Closed" })
]);

// MARK: - Partner Referral Status

export const litigationPartnerReferralStatuses = Object.freeze([
  "draft",
  "sent",
  "viewed",
  "underReview",
  "accepted",
  "declined",
  "withdrawn",
  "expired"
]);

// MARK: - Submission Message Contract

export const litigationSubmissionMessageVisibilities = Object.freeze([
  "internal",
  "client"
]);

export const litigationSubmissionMessageSenderRoles = Object.freeze([
  "firm",
  "client",
  "system"
]);

export const litigationSubmissionMessageDeliveryStatuses = Object.freeze([
  "saved",
  "queued",
  "delivered",
  "failed",
  "read"
]);
